"use client";

import React from "react";

interface FallbackProps {
  error?: Error;
  resetError: () => void;
  message?: string;
  isResetting: boolean;
}

const FallbackUI: React.FC<FallbackProps> = ({
  error,
  resetError,
  message = "We're sorry, but there was an error loading this component.",
  isResetting,
}) => (
  <div className="flex flex-col items-center justify-center rounded-lg border border-gray-100 bg-white p-4 shadow-sm">
    <div className="mb-4 text-red-500">
      <svg
        xmlns="http://www.w3.org/2000/svg"
        className="h-12 w-12"
        fill="none"
        viewBox="0 0 24 24"
        stroke="currentColor"
      >
        <path
          strokeLinecap="round"
          strokeLinejoin="round"
          strokeWidth={2}
          d="M12 9v2m0 4h.01m-6.938 4h13.856c1.54 0 2.502-1.667 1.732-3L13.732 4c-.77-1.333-2.694-1.333-3.464 0L3.34 16c-.77 1.333.192 3 1.732 3z"
        />
      </svg>
    </div>
    <h2 className="mb-2 text-xl font-bold text-gray-800">
      Something went wrong
    </h2>
    <p className="mb-4 text-center text-gray-600">{message}</p>
    {error && process.env.ENVIRONMENT === "development" && (
      <div className="mb-4 max-w-full overflow-auto rounded bg-gray-50 p-3 text-sm text-gray-600">
        <p className="font-medium">Error details:</p>
        <p className="font-mono">{error.message}</p>
      </div>
    )}
    <button
      onClick={resetError}
      disabled={isResetting}
      className="flex items-center gap-2 rounded bg-blue-500 px-4 py-2 text-white transition-colors hover:bg-blue-600 focus:outline-none focus:ring-2 focus:ring-blue-500 focus:ring-opacity-50 disabled:cursor-not-allowed disabled:opacity-50"
    >
      {isResetting ? (
        <>
          <svg className="h-4 w-4 animate-spin" viewBox="0 0 24 24">
            <circle
              className="opacity-25"
              cx="12"
              cy="12"
              r="10"
              stroke="currentColor"
              strokeWidth="4"
              fill="none"
            />
            <path
              className="opacity-75"
              fill="currentColor"
              d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"
            />
          </svg>
          Retrying...
        </>
      ) : (
        "Try Again"
      )}
    </button>
  </div>
);

export default FallbackUI;
